// extracted by mini-css-extract-plugin
export default {"resetButton":"f_DCHOC","statItemLevel2":"C1Svrj7","statItemLevel3":"joVopQV","labelTooltip":"fN4VYt1"};